"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icons = void 0;
var arrows_surround_converge_point_icon_1 = require("./arrows-surround-converge-point.icon");
var arrows_toward_person_circle_icon_1 = require("./arrows-toward-person-circle.icon");
var arrow_down_circle_icon_1 = require("./arrow-down-circle.icon");
var arrow_left_circle_icon_1 = require("./arrow-left-circle.icon");
var arrow_right_circle_icon_1 = require("./arrow-right-circle.icon");
var arrow_up_circle_icon_1 = require("./arrow-up-circle.icon");
var ban_circle_icon_1 = require("./ban-circle.icon");
var bar_chart_circle_icon_1 = require("./bar-chart-circle.icon");
var bookmark_circle_icon_1 = require("./bookmark-circle.icon");
var bracket_bottom_right_icon_1 = require("./bracket-bottom-right.icon");
var bracket_top_left_icon_1 = require("./bracket-top-left.icon");
var briefcase_circle_icon_1 = require("./briefcase-circle.icon");
var building_arrow_circle_icon_1 = require("./building-arrow-circle.icon");
var building_circle_icon_1 = require("./building-circle.icon");
var building_heart_circle_icon_1 = require("./building-heart-circle.icon");
var building_opposing_arrows_circle_icon_1 = require("./building-opposing-arrows-circle.icon");
var c_circle_icon_1 = require("./c-circle.icon");
var chat_dots_circle_icon_1 = require("./chat-dots-circle.icon");
var chat_lines_circle_icon_1 = require("./chat-lines-circle.icon");
var chat_radial_dots_circle_icon_1 = require("./chat-radial-dots-circle.icon");
var chevron_double_left_icon_1 = require("./chevron-double-left.icon");
var chevron_double_right_icon_1 = require("./chevron-double-right.icon");
var chevron_down_icon_1 = require("./chevron-down.icon");
var chevron_left_icon_1 = require("./chevron-left.icon");
var chevron_left_circle_icon_1 = require("./chevron-left-circle.icon");
var chevron_right_icon_1 = require("./chevron-right.icon");
var chevron_right_circle_icon_1 = require("./chevron-right-circle.icon");
var chevron_up_down_circle_icon_1 = require("./chevron-up-down-circle.icon");
var chevron_down_circle_icon_1 = require("./chevron-down-circle.icon");
var chevron_up_icon_1 = require("./chevron-up.icon");
var chevron_up_circle_icon_1 = require("./chevron-up-circle.icon");
var circuit_circle_icon_1 = require("./circuit-circle.icon");
var cog_node_circle_icon_1 = require("./cog-node-circle.icon");
var cross_icon_1 = require("./cross.icon");
var cross_circle_icon_1 = require("./cross-circle.icon");
var crosshair_circle_icon_1 = require("./crosshair-circle.icon");
var crosshair_dot_circle_icon_1 = require("./crosshair-dot-circle.icon");
var currency_circle_icon_1 = require("./currency-circle.icon");
var dashboard_screen_circle_icon_1 = require("./dashboard-screen-circle.icon");
var document_circle_icon_1 = require("./document-circle.icon");
var dollar_heart_circle_icon_1 = require("./dollar-heart-circle.icon");
var dot_heart_circle_icon_1 = require("./dot-heart-circle.icon");
var dot_pattern_circle_icon_1 = require("./dot-pattern-circle.icon");
var dot_pattern_symmetrical_circle_icon_1 = require("./dot-pattern-symmetrical-circle.icon");
var dots_radius_circle_icon_1 = require("./dots-radius-circle.icon");
var double_quotes_circle_icon_1 = require("./double-quotes-circle.icon");
var ellipsis_circle_icon_1 = require("./ellipsis-circle.icon");
var ellipsis_node_circle_icon_1 = require("./ellipsis-node-circle.icon");
var exclamation_icon_1 = require("./exclamation.icon");
var exclamation_circle_icon_1 = require("./exclamation-circle.icon");
var explore_icon_1 = require("./explore.icon");
var fade_arrow_down_icon_1 = require("./fade-arrow-down.icon");
var fade_arrow_right_icon_1 = require("./fade-arrow-right.icon");
var fast_forward_circle_icon_1 = require("./fast-forward-circle.icon");
var feed_icon_1 = require("./feed.icon");
var focus_node_five_nodes_circle_icon_1 = require("./focus-node-five-nodes-circle.icon");
var frame_circle_icon_1 = require("./frame-circle.icon");
var gears_circle_icon_1 = require("./gears-circle.icon");
var hamburger_icon_1 = require("./hamburger.icon");
var info_circle_icon_1 = require("./info-circle.icon");
var left_single_quote_icon_1 = require("./left-single-quote.icon");
var light_globe_circle_icon_1 = require("./light-globe-circle.icon");
var minus_circle_icon_1 = require("./minus-circle.icon");
var node_ellipsis_circle_icon_1 = require("./node-ellipsis-circle.icon");
var open_ai_icon_1 = require("./open-ai.icon");
var open_ai_generate_icon_1 = require("./open-ai-generate.icon");
var page_no_circle_icon_1 = require("./page-no-circle.icon");
var pencil_circle_icon_1 = require("./pencil-circle.icon");
var people_circle_icon_1 = require("./people-circle.icon");
var person_circle_icon_1 = require("./person-circle.icon");
var person_podium_circle_icon_1 = require("./person-podium-circle.icon");
var person_heart_circle_icon_1 = require("./person-heart-circle.icon");
var pie_chart_circle_icon_1 = require("./pie-chart-circle.icon");
var pin_icon_1 = require("./pin.icon");
var pin_circle_icon_1 = require("./pin-circle.icon");
var pin_web_circle_icon_1 = require("./pin-web-circle.icon");
var pin_dots_circle_icon_1 = require("./pin-dots-circle.icon");
var pin_dots_square_icon_1 = require("./pin-dots-square.icon");
var play_icon_1 = require("./play.icon");
var play_vertical_line_circle_icon_1 = require("./play-vertical-line-circle.icon");
var plus_circle_icon_1 = require("./plus-circle.icon");
var point_circle_dots_frame_1 = require("./point-circle-dots-frame");
var point_spin_hexagon_icon_1 = require("./point-spin-hexagon.icon");
var quote_circle_icon_1 = require("./quote-circle.icon");
var right_single_quote_icon_1 = require("./right-single-quote.icon");
var search_circle_icon_1 = require("./search-circle.icon");
var search_radial_dots_circle_icon_1 = require("./search-radial-dots-circle.icon");
var star_dots_icon_1 = require("./star-dots.icon");
var stamped_document_tick_circle_icon_1 = require("./stamped-document-tick-circle.icon");
var target_icon_1 = require("./target.icon");
var target_circle_icon_1 = require("./target-circle.icon");
var text_circle_icon_1 = require("./text-circle.icon");
var three_nodes_circle_icon_1 = require("./three-nodes-circle.icon");
var three_lines_circle_icon_1 = require("./three-lines-circle.icon");
var tick_circle_icon_1 = require("./tick-circle.icon");
var tick_icon_1 = require("./tick.icon");
var triangle_down_icon_1 = require("./triangle-down.icon");
var triangle_right_icon_1 = require("./triangle-right.icon");
var vertical_dots_circle_icon_1 = require("./vertical-dots-circle.icon");
var vertical_line_circle_icon_1 = require("./vertical-line-circle.icon");
var vertical_line_play_circle_icon_1 = require("./vertical-line-play-circle.icon");
var sidebar_menu_icon_1 = require("./sidebar-menu.icon");
var sidebar_menu_collapse_icon_1 = require("./sidebar-menu-collapse.icon");
var crosshair_circle_icon_2 = require("./crosshair-circle.icon");
var person_circle_icon_2 = require("./person-circle.icon");
var social_1 = require("./social");
var AppSections = __importStar(require("./app-sections"));
var Toolbar = __importStar(require("./toolbar"));
var sdg_1 = require("./sdg");
var Challenge = {
  // TODO - provide some defaults here
};
var EntityIcons = __importStar(require("./entities"));
var Platforms = __importStar(require("./platforms"));
var OfferingType = {
  Policy: stamped_document_tick_circle_icon_1.StampedDocumentTickCircle,
  Technology: circuit_circle_icon_1.CircuitCircle,
  Service: arrows_toward_person_circle_icon_1.ArrowsTowardPersonCircle,
  BusinessModel: building_opposing_arrows_circle_icon_1.BuildingOpposingArrowsCircle,
  Investment: currency_circle_icon_1.CurrencyCircle,
  Narrative: chat_lines_circle_icon_1.ChatLinesCircle,
  Reference: three_lines_circle_icon_1.ThreeLinesCircle,
  Research: light_globe_circle_icon_1.LightGlobeCircle,
  Trend: chat_dots_circle_icon_1.ChatDotsCircle
};
var OrganisationType = {
  AssociationAffiliate: building_heart_circle_icon_1.BuildingHeartCircle,
  AssociationNetwork: circuit_circle_icon_1.CircuitCircle,
  Corporation: building_circle_icon_1.BuildingCircle,
  Government: person_podium_circle_icon_1.PersonPodiumCircle,
  Investor: currency_circle_icon_1.CurrencyCircle,
  CareProvider: building_heart_circle_icon_1.BuildingHeartCircle,
  Startup: building_arrow_circle_icon_1.BuildingArrowCircle,
  ThinkTankFoundation: light_globe_circle_icon_1.LightGlobeCircle
};
var ProjectStatus = {
  NotStarted: vertical_line_circle_icon_1.VerticalLineCircle,
  UnderRequest: play_vertical_line_circle_icon_1.PlayVerticalLineCircle,
  Briefing: three_lines_circle_icon_1.ThreeLinesCircle,
  InProgress: vertical_line_play_circle_icon_1.VerticalLinePlayCircle,
  Ongoing: fast_forward_circle_icon_1.FastForwardCircle
};
var Shapeable = {
  AccelerateNewMarkets: arrows_surround_converge_point_icon_1.ArrowsSurroundConvergePoint,
  Business: building_circle_icon_1.BuildingCircle,
  City: pin_circle_icon_1.PinCircle,
  Country: pin_dots_square_icon_1.PinDotsSquare,
  FrameYourChallenge: point_circle_dots_frame_1.PointCircleDotsFrame,
  InternationalOrganisation: dot_heart_circle_icon_1.DotHeartCircle,
  MapYourComplexity: star_dots_icon_1.StarDots,
  Philanthropist: person_heart_circle_icon_1.PersonHeartCircle,
  ShapeYourSolutions: point_spin_hexagon_icon_1.PointSpinHexagon,
  SocialEnterprise: building_heart_circle_icon_1.BuildingHeartCircle,
  Startup: building_arrow_circle_icon_1.BuildingArrowCircle,
  Topic: target_icon_1.Target
};
var Social = {
  Email: social_1.Email,
  Phone: social_1.Phone,
  Facebook: social_1.Facebook,
  FacebookCircle: social_1.FacebookCircle,
  FacebookFilledCircle: social_1.FacebookFilledCircleIcon,
  FlickrFilledCircle: social_1.FlickrFilledCircleIcon,
  InstagramFilledCircle: social_1.InstagramFilledCircleIcon,
  TikTokFilledCircle: social_1.TikTokFilledCircleIcon,
  XFilledCircle: social_1.XFilledCircleIcon,
  ThreadsFilledCircle: social_1.ThreadsFilledCircleIcon,
  Twitter: social_1.Twitter,
  TwitterCircle: social_1.TwitterCircle,
  TwitterFilledCircle: social_1.TwitterFilledCircleIcon,
  Linkedin: social_1.Linkedin,
  LinkedinCircle: social_1.LinkedinCircle,
  LinkedinFilledCircle: social_1.LinkedinFilledCircleIcon,
  WebFilledCircle: social_1.WebFilledCircleIcon,
  Youtube: social_1.Youtube,
  YoutubeFilledCircle: social_1.YouTubeFilledCircleIcon
};
var Entities = __assign(__assign({}, EntityIcons), {
  Author: EntityIcons.Person,
  HorizonType: EntityIcons.Indicator,
  Region: EntityIcons.State,
  GlobalRegion: EntityIcons.State,
  Space: EntityIcons.Team,
  SpaceRole: EntityIcons.TeamRole,
  SpaceType: EntityIcons.TeamType,
  SpaceMembership: EntityIcons.TeamRole,
  MembershipStatus: EntityIcons.ProjectStatus,
  ChallengeExpertise: stamped_document_tick_circle_icon_1.StampedDocumentTickCircle,
  KeyIssueExpertise: stamped_document_tick_circle_icon_1.StampedDocumentTickCircle,
  SdgExpertise: stamped_document_tick_circle_icon_1.StampedDocumentTickCircle,
  SubTopicExpertise: stamped_document_tick_circle_icon_1.StampedDocumentTickCircle,
  TopicExpertise: stamped_document_tick_circle_icon_1.StampedDocumentTickCircle,
  TrendExpertise: stamped_document_tick_circle_icon_1.StampedDocumentTickCircle,
  Technology: light_globe_circle_icon_1.LightGlobeCircle,
  Program: EntityIcons.Layout,
  IndicatorLayout: EntityIcons.Block,
  IndicatorGroupLayout: EntityIcons.Slice,
  EntityType: frame_circle_icon_1.FrameCircle,
  Icon: EntityIcons.Indicator,
  Menu: three_lines_circle_icon_1.ThreeLinesCircle,
  MenuItem: EntityIcons.Slice,
  Trend: EntityIcons.Challenge,
  Status: tick_circle_icon_1.TickCircle,
  SubTopic: EntityIcons.KeyIssue,
  Topic: EntityIcons.KeyIssue,
  Editor: EntityIcons.Person,
  Publisher: pencil_circle_icon_1.PencilCircle,
  Keyword: frame_circle_icon_1.FrameCircle,
  Citation: bookmark_circle_icon_1.BookmarkCircle,
  CitationType: EntityIcons.Role,
  Permission: EntityIcons.UserPermission,
  PermissionType: EntityIcons.UserPermission,
  Podcast: EntityIcons.Video,
  Post: EntityIcons.ImpactStory,
  PostType: EntityIcons.ImpactResultType,
  PodcastType: EntityIcons.ImpactResultType,
  PageType: EntityIcons.ImpactResultType,
  CourseRole: EntityIcons.UserPermission,
  LessonRole: EntityIcons.UserPermission,
  SessionRole: EntityIcons.UserPermission,
  EventRole: EntityIcons.UserPermission,
  ProductRole: EntityIcons.UserPermission,
  ObjectiveType: EntityIcons.Project,
  OrganisationEventRole: EntityIcons.OrganisationTeamRole,
  OrganisationSessionRole: EntityIcons.OrganisationTeamRole,
  OrganisationProductRole: EntityIcons.OrganisationTeamRole,
  Place: EntityIcons.Location,
  Product: light_globe_circle_icon_1.LightGlobeCircle,
  Color: dots_radius_circle_icon_1.DotsRadiusCircle,
  Comment: quote_circle_icon_1.QuoteCircle,
  Task: tick_circle_icon_1.TickCircle,
  Language: EntityIcons.ImpactStory,
  Species: EntityIcons.Industry,
  RestorationProject: EntityIcons.ImpactStory,
  Motivation: EntityIcons.Challenge,
  Observation: EntityIcons.Event,
  Reason: EntityIcons.KeyIssue,
  PageLayout: EntityIcons.Layout,
  View: EntityIcons.Layout,
  Room: pin_circle_icon_1.PinCircle,
  SessionGroup: EntityIcons.ImpactResultType,
  Venue: pin_circle_icon_1.PinCircle,
  Variable: EntityIcons.Indicator,
  EcologicalPrinciple: EntityIcons.ImpactResult,
  Methodology: EntityIcons.Benefit,
  ImpactType: EntityIcons.ImpactResultType,
  SentimentType: EntityIcons.ImpactResultType,
  CommodityGroup: EntityIcons.Challenge
});
var Sdg = {
  AffordableCleanEnergy: sdg_1.AffordableCleanEnergy,
  CleanerWaterSanitation: sdg_1.CleanerWaterSanitation,
  ClimateAction: sdg_1.ClimateAction,
  DecentWorkAndEconomicGrowth: sdg_1.DecentWorkAndEconomicGrowth,
  GenderEquality: sdg_1.GenderEquality,
  GoodHealthAndWellbeing: sdg_1.GoodHealthAndWellbeing,
  IndustryInnovationAndInfrastructure: sdg_1.IndustryInnovationAndInfrastructure,
  LifeBelowWater: sdg_1.LifeBelowWater,
  LifeOnLand: sdg_1.LifeOnLand,
  NoPoverty: sdg_1.NoPoverty,
  Partnerships: sdg_1.Partnerships,
  PeaceJusticeAndStrongInstitutions: sdg_1.PeaceJusticeAndStrongInstitutions,
  QualityEducation: sdg_1.QualityEducation,
  ReducedInequalities: sdg_1.ReducedInequalities,
  ResponsibleConsumptionAndProduction: sdg_1.ResponsibleConsumptionAndProduction,
  SustainableCitiesAndCommunities: sdg_1.SustainableCitiesAndCommunities,
  ZeroHunger: sdg_1.ZeroHunger
};
exports.Icons = {
  ArrowsSurroundConvergePoint: arrows_surround_converge_point_icon_1.ArrowsSurroundConvergePoint,
  ArrowsTowardPersonCircle: arrows_toward_person_circle_icon_1.ArrowsTowardPersonCircle,
  ArrowDownCircle: arrow_down_circle_icon_1.ArrowDownCircle,
  ArrowLeftCircle: arrow_left_circle_icon_1.ArrowLeftCircle,
  ArrowRightCircle: arrow_right_circle_icon_1.ArrowRightCircle,
  ArrowUpCircle: arrow_up_circle_icon_1.ArrowUpCircle,
  BanCircle: ban_circle_icon_1.BanCircle,
  BarChartCircle: bar_chart_circle_icon_1.BarChartCircle,
  BookmarkCircle: bookmark_circle_icon_1.BookmarkCircle,
  BracketBottomRight: bracket_bottom_right_icon_1.BracketBottomRight,
  BracketTopLeft: bracket_top_left_icon_1.BracketTopLeft,
  BriefcaseCircle: briefcase_circle_icon_1.BriefcaseCircle,
  BuildingArrowCircle: building_arrow_circle_icon_1.BuildingArrowCircle,
  BuildingCircle: building_circle_icon_1.BuildingCircle,
  BuildingHeartCircle: building_heart_circle_icon_1.BuildingHeartCircle,
  BuildingOpposingArrowsCircle: building_opposing_arrows_circle_icon_1.BuildingOpposingArrowsCircle,
  CCircle: c_circle_icon_1.CCircle,
  ChatDotsCircle: chat_dots_circle_icon_1.ChatDotsCircle,
  ChatLinesCircle: chat_lines_circle_icon_1.ChatLinesCircle,
  ChatRadialDotsCircle: chat_radial_dots_circle_icon_1.ChatRadialDotsCircle,
  ChevronDoubleLeft: chevron_double_left_icon_1.ChevronDoubleLeft,
  ChevronDoubleRight: chevron_double_right_icon_1.ChevronDoubleRight,
  ChevronDown: chevron_down_icon_1.ChevronDown,
  ChevronLeft: chevron_left_icon_1.ChevronLeft,
  ChevronLeftCircle: chevron_left_circle_icon_1.ChevronLeftCircle,
  ChevronRight: chevron_right_icon_1.ChevronRight,
  ChevronRightCircle: chevron_right_circle_icon_1.ChevronRightCircle,
  ChevronUpDownCircle: chevron_up_down_circle_icon_1.ChevronUpDownCircle,
  ChevronDownCircle: chevron_down_circle_icon_1.ChevronDownCircle,
  ChevronUpCircle: chevron_up_circle_icon_1.ChevronUpCircle,
  ChevronUp: chevron_up_icon_1.ChevronUp,
  CircuitCircle: circuit_circle_icon_1.CircuitCircle,
  CogNodeCircle: cog_node_circle_icon_1.CogNodeCircle,
  Cross: cross_icon_1.Cross,
  CrossCircle: cross_circle_icon_1.CrossCircle,
  CrosshairCircle: crosshair_circle_icon_1.CrosshairCircle,
  CrosshairDotCircle: crosshair_dot_circle_icon_1.CrosshairDotCircle,
  CurrencyCircle: currency_circle_icon_1.CurrencyCircle,
  DashboardScreenCircle: dashboard_screen_circle_icon_1.DashboardScreenCircle,
  DocumentCircle: document_circle_icon_1.DocumentCircle,
  DollarHeartCircle: dollar_heart_circle_icon_1.DollarHeartCircle,
  DotHeartCircle: dot_heart_circle_icon_1.DotHeartCircle,
  DotPatternCircle: dot_pattern_circle_icon_1.DotPatternCircle,
  DotPatternSymmetricalCircle: dot_pattern_symmetrical_circle_icon_1.DotPatternSymmetricalCircle,
  DotsRadiusCircle: dots_radius_circle_icon_1.DotsRadiusCircle,
  DoubleQuotesCircle: double_quotes_circle_icon_1.DoubleQuotesCircle,
  EllipsisCircle: ellipsis_circle_icon_1.EllipsisCircle,
  EllipsisNodeCircle: ellipsis_node_circle_icon_1.EllipsisNodeCircle,
  Exclamation: exclamation_icon_1.Exclamation,
  ExclamationCircle: exclamation_circle_icon_1.ExclamationCircle,
  Explore: explore_icon_1.Explore,
  FadeArrowDown: fade_arrow_down_icon_1.FadeArrowDown,
  FadeArrowRight: fade_arrow_right_icon_1.FadeArrowRight,
  FastForwardCircle: fast_forward_circle_icon_1.FastForwardCircle,
  Feed: feed_icon_1.Feed,
  FocusNodeFiveNodesCircle: focus_node_five_nodes_circle_icon_1.FocusNodeFiveNodesCircle,
  FrameCircle: frame_circle_icon_1.FrameCircle,
  GearsCircle: gears_circle_icon_1.GearsCircle,
  Hamburger: hamburger_icon_1.Hamburger,
  Industry: crosshair_circle_icon_2.CrosshairCircle,
  InfoCircle: info_circle_icon_1.InfoCircle,
  LeftSingleQuote: left_single_quote_icon_1.LeftSingleQuote,
  LightGlobeCircle: light_globe_circle_icon_1.LightGlobeCircle,
  MinusCircle: minus_circle_icon_1.MinusCircle,
  NodeEllipsisCircle: node_ellipsis_circle_icon_1.NodeEllipsisCircle,
  OpenAI: open_ai_icon_1.OpenAI,
  OpenAIGenerate: open_ai_generate_icon_1.OpenAIGenerate,
  PageNoCircle: page_no_circle_icon_1.PageNoCircle,
  PencilCircle: pencil_circle_icon_1.PencilCircle,
  PeopleCircle: people_circle_icon_1.PeopleCircle,
  PersonCircle: person_circle_icon_1.PersonCircle,
  PersonPodiumCircle: person_podium_circle_icon_1.PersonPodiumCircle,
  PersonHeartCircle: person_heart_circle_icon_1.PersonHeartCircle,
  PieChartCircle: pie_chart_circle_icon_1.PieChartCircle,
  Pin: pin_icon_1.Pin,
  PinCircle: pin_circle_icon_1.PinCircle,
  PinWebCircle: pin_web_circle_icon_1.PinWebCircle,
  PinDotsCircle: pin_dots_circle_icon_1.PinDotsCircle,
  PinDotsSquare: pin_dots_square_icon_1.PinDotsSquare,
  Play: play_icon_1.Play,
  PlayVerticalLineCircle: play_vertical_line_circle_icon_1.PlayVerticalLineCircle,
  PlusCircle: plus_circle_icon_1.PlusCircle,
  Profile: person_circle_icon_2.PersonCircle,
  PointCircleDotsFrame: point_circle_dots_frame_1.PointCircleDotsFrame,
  PointSpinHexagon: point_spin_hexagon_icon_1.PointSpinHexagon,
  QuoteCircle: quote_circle_icon_1.QuoteCircle,
  RightSingleQuote: right_single_quote_icon_1.RightSingleQuote,
  SearchCircle: search_circle_icon_1.SearchCircle,
  SearchRadialDotsCircle: search_radial_dots_circle_icon_1.SearchRadialDotsCircle,
  SidebarMenu: sidebar_menu_icon_1.SidebarMenu,
  SidebarMenuCollapse: sidebar_menu_collapse_icon_1.SidebarMenuCollapse,
  StarDots: star_dots_icon_1.StarDots,
  StampedDocumentTickCircle: stamped_document_tick_circle_icon_1.StampedDocumentTickCircle,
  Target: target_icon_1.Target,
  TargetCircle: target_circle_icon_1.TargetCircle,
  TextCircle: text_circle_icon_1.TextCircle,
  ThreeLinesCircle: three_lines_circle_icon_1.ThreeLinesCircle,
  ThreeNodesCircle: three_nodes_circle_icon_1.ThreeNodesCircle,
  TickCircle: tick_circle_icon_1.TickCircle,
  Tick: tick_icon_1.Tick,
  TriangleDown: triangle_down_icon_1.TriangleDown,
  TriangleRight: triangle_right_icon_1.TriangleRight,
  VerticalDotsCircle: vertical_dots_circle_icon_1.VerticalDotsCircle,
  VerticalLineCircle: vertical_line_circle_icon_1.VerticalLineCircle,
  VerticalLinePlayCircle: vertical_line_play_circle_icon_1.VerticalLinePlayCircle,
  Entities: Entities,
  AppSections: AppSections,
  Toolbar: Toolbar,
  Platforms: Platforms,
  Challenge: Challenge,
  OfferingType: OfferingType,
  OrganisationType: OrganisationType,
  ProjectStatus: ProjectStatus,
  Sdg: Sdg,
  Shapeable: Shapeable,
  Social: Social
};